import React from 'react';
import AddStrategies from '../../component/strategies/add-container';

export default () => (<AddStrategies />);



// WEBPACK FOOTER //
// ./src/page/strategies/create.js